<img *ngIf="name" src="assets/proof-life/{{name}}.svg" class="icon-svg" [attr.width]="width" [attr.height]="height" />